import store from '../../../core/store';

export const listMyCompanyMembers = () => {
  return store.dispatch({
    action: 'table.my_company_members/LIST_MY_COMPANY_MEMBERS',
    method: 'GET',
    endpoint: '/companies/my/members',
    main: true,
  });
};

export const refreshMyCompanyMembers = () => {
  return store.dispatch({
    action: 'table.my_company_members/LIST_MY_COMPANY_MEMBERS',
    method: 'GET',
    endpoint: '/companies/my/members',
    main: true,
    preloaded: false,
  });
};

export const updateCompanyMemberRole = (user_id, role) => {
  return store.dispatch({
    action: 'table.my_company_members/UPDATE_COMPANY_MEMBER_ROLE',
    method: 'PUT',
    endpoint: '/companies/my/members/' + user_id + '/role',
    data: {
      role,
    },
  });
};

export const inviteNewCompanyMember = (postData) => {
  return store.dispatch({
    action: 'table.my_company_members/INVITE_NEW_COMPANY_MEMBER',
    method: 'POST',
    endpoint: '/companies/my/members/invite',
    data: postData,
  });
};

export const resendCompanyJoinInvitation = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/RESEND_COMPANY_JOIN_INVITATION',
    method: 'POST',
    endpoint: '/companies/my/join_invitations/' + id + '/resend',
  });
};

export const updateCompanyInvitationRole = (id, role) => {
  return store.dispatch({
    action: 'table.my_company_members/UPDATE_COMPANY_INVITATION_ROLE',
    method: 'PUT',
    endpoint: '/companies/my/join_invitations/' + id + '/role',
    data: {
      role,
    },
  });
};

export const approveCompanyJoinRequest = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/APPROVE_COMPANY_JOIN_REQUEST',
    method: 'PUT',
    endpoint: '/companies/my/join_requests/' + id + '/approve',
  });
};

export const declineCompanyJoinRequest = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/DECLINE_COMPANY_JOIN_REQUEST',
    method: 'DELETE',
    endpoint: '/companies/my/join_requests/' + id + '/decline',
  });
};

export const cancelCompanyJoinRequest = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/CANCEL_COMPANY_JOIN_REQUEST',
    method: 'DELETE',
    endpoint: '/companies/my/join_invitations/' + id + '/cancel',
  });
};

export const deactivateCompanyMember = (user_id) => {
  return store.dispatch({
    action: 'table.my_company_members/DEACTIVATE_COMPANY_MEMBER',
    method: 'PUT',
    endpoint: '/company/members/' + user_id + '/deactivate',
  });
};

export const reactivateCompanyMember = (user_id) => {
  return store.dispatch({
    action: 'table.my_company_members/REACTIVATE_COMPANY_MEMBER',
    method: 'PUT',
    endpoint: '/company/members/' + user_id + '/reactivate',
  });
};

export const readCompanyMember = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/READ_COMPANY_MEMBER',
    method: 'GET',
    endpoint: '/profile/details/' + id,
  });
};

export const readCompanyMemberEmploymentTerms = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/READ_COMPANY_MEMBER_EMPLOYMENT_TERMS',
    method: 'GET',
    endpoint: '/user_employment_terms/active/' + id,
  });
};

export const updateCompanyMemberDetails = (formData) => {
  return store.dispatch({
    action: 'table.my_company_members/UPDATE_COMPANY_MEMBER_DETAILS',
    method: 'PUT',
    endpoint: '/profile/details',
    data: formData,
  });
};

export const updateCompanyMemberEmploymentTerms = (id, formData) => {
  return store.dispatch({
    action: 'table.my_company_members/UPDATE_COMPANY_MEMBER_EMPLOYMENT_TERMS',
    method: 'PUT',
    endpoint: '/user_employment_terms/' + id,
    data: formData,
  });
};

export const readCompanyMemberEmploymentTermsGeneralData = (id) => {
  return store.dispatch({
    action:
      'table.my_company_members/READ_COMPANY_MEMBER_EMPLOYMENT_TERMS_GENERAL_DATA',
    method: 'GET',
    endpoint: '/profile/details/employment_terms/general/' + id,
  });
};

export const updateCompanyMemberEmploymentTermsGeneralData = (formData) => {
  return store.dispatch({
    action:
      'table.my_company_members/UPDATE_COMPANY_MEMBER_EMPLOYMENT_TERMS_GENERAL_DATA',
    method: 'POST',
    endpoint: '/profile/details/employment_terms/general',
    data: formData,
  });
};

export const readCompanyMemberEmploymentTermsDaysData = (id) => {
  return store.dispatch({
    action:
      'table.my_company_members/READ_COMPANY_MEMBER_EMPLOYMENT_TERMS_DAYS_DATA',
    method: 'GET',
    endpoint: '/profile/details/employment_terms/hours/' + id,
  });
};

export const updateCompanyMemberEmploymentTermsDaysData = (formData) => {
  return store.dispatch({
    action:
      'table.my_company_members/UPDATE_COMPANY_MEMBER_EMPLOYMENT_TERMS_DAYS_DATA',
    method: 'POST',
    endpoint: '/profile/details/employment_terms/hours',
    data: formData,
  });
};

export const readCompanyMemberEmploymentTermsTimeOffData = (id) => {
  return store.dispatch({
    action:
      'table.my_company_members/READ_COMPANY_MEMBER_EMPLOYMENT_TERMS_TIME_OFF_DATA',
    method: 'GET',
    endpoint: '/profile/details/employment_terms/time_off/' + id,
  });
};

export const updateCompanyMemberEmploymentTermsTimeOffData = (formData) => {
  return store.dispatch({
    action:
      'table.my_company_members/UPDATE_COMPANY_MEMBER_EMPLOYMENT_TERMS_TIME_OFF_DATA',
    method: 'POST',
    endpoint: '/profile/details/employment_terms/time_off',
    data: formData,
  });
};

export const readCompanyMemberFinancialPaycheckData = (id) => {
  return store.dispatch({
    action:
      'table.my_company_members/READ_COMPANY_MEMBER_FINANCIAL_PAYCHECK_DATA',
    method: 'GET',
    endpoint: '/profile/details/compensation_paycheck/' + id,
  });
};

export const updateCompanyMemberFinancialPaycheckData = (formData) => {
  return store.dispatch({
    action:
      'table.my_company_members/UPDATE_COMPANY_MEMBER_FINANCIAL_PAYCHECK_DATA',
    method: 'POST',
    endpoint: '/profile/details/compensation_paycheck',
    data: formData,
  });
};

export const readCompanyMemberFinancialRateData = (id) => {
  return store.dispatch({
    action: 'table.my_company_members/READ_COMPANY_MEMBER_FINANCIAL_RATE_DATA',
    method: 'GET',
    endpoint: '/profile/details/compensation_rate/' + id,
  });
};

export const updateCompanyMemberFinancialRateData = (formData) => {
  return store.dispatch({
    action:
      'table.my_company_members/UPDATE_COMPANY_MEMBER_FINANCIAL_RATE_DATA',
    method: 'POST',
    endpoint: '/profile/details/compensation_rate',
    data: formData,
  });
};

export const uploadHrFiles = (files) => {
  return store.dispatch({
    action: 'table.my_company_members/UPLOAD_HR_FILES',
    method: 'POST',
    endpoint: '/hr_folders/upload',
    data: {
      files,
    },
  });
};

export const deleteHrFile = (file_id) => {
  return store.dispatch({
    action: 'table.my_company_members/DELETE_HR_FILE',
    method: 'DELETE',
    endpoint: '/hr_folders/delete_file/' + file_id,
  });
};

export const updateHrFile = (file) => {
  return store.dispatch({
    action: 'table.my_company_members/DELETE_HR_FILE',
    method: 'POST',
    endpoint: '/hr_folders/edit_files',
    data: file,
  });
};

export const readMyCompanyMemberHistory = (user_id) => {
  return store.dispatch({
    action: 'table.my_company_members/READ_MY_COMPANY_MEMBER_HISTORY',
    method: 'GET',
    endpoint: '/profile/details/' + user_id + '/history',
  });
};
